import { useCallback } from "react";

import { useSelector } from "react-redux";

import { DemoDisabledTooltip } from "app/pages/sales-intelligence/common-components/demo-mode/DemoDisabledTooltip";
import {
    StyledInnerContainer,
    TableActionsPanel,
} from "app/pages/sales-intelligence/common-components/table-actions-panel";
import { isStaticList } from "app/pages/sales-intelligence/domain/lists/utils/list-variant";
import { useDemoModeDisabled } from "app/pages/sales-intelligence/hooks/demo-mode/useDemoModeDisabled";
import { selectActiveLeadsType } from "app/pages/sales-intelligence/modules/leads-search";
import { useListParams } from "app/pages/sales-intelligence/modules/lists/context/ListParamsContext";
import { useColumnsConfigQuery } from "app/pages/sales-intelligence/modules/lists/query/queries/useColumnsConfigQuery";
import { useColumnSelectionMutation } from "app/pages/sales-intelligence/modules/lists/query/queries/useColumnSelectionMutation";

import { useLeadsResultsActionsState } from "../../../hooks/useLeadsResultsActionsState";
import SelectionModalContainer from "../SelectionModal/SelectionModalContainer";
import TableListsColumnsSelectionContainer from "../TableColumnSelection/TableListsColumnsSelectionContainer";
import TableExportOptionsContainer from "../TableExportOptions/TableExportOptionsContainer";

import StaticListTableActionsContainer from "./StaticListTableActionsContainer";

const TableActionsPanelContainer = () => {
    const activeLeadsType = useSelector(selectActiveLeadsType);

    const { mutateAsync, isPending } = useColumnSelectionMutation();

    const listParams = useListParams();

    const { isSuccess: isColumnConfigReady } = useColumnsConfigQuery();

    const { areActionsDisabled } = useLeadsResultsActionsState(activeLeadsType);

    const { isDisabled: isDemoMode } = useDemoModeDisabled();
    const areWriteActionsDisabled = areActionsDisabled || isDemoMode;

    const handleSuggestionsApply = useCallback(
        async (newColumnsSet: readonly string[]) => {
            await mutateAsync({ columns: newColumnsSet });
        },
        [mutateAsync],
    );

    return (
        <TableActionsPanel>
            {({ activate }) => (
                <>
                    <StyledInnerContainer>
                        <TableExportOptionsContainer
                            isDisabled={areActionsDisabled}
                            isCrmExportDisabled={isDemoMode}
                            onActivate={activate}
                        />

                        {isStaticList(listParams) ? (
                            <DemoDisabledTooltip>
                                <StaticListTableActionsContainer
                                    isDisabled={areWriteActionsDisabled}
                                    onActivate={activate}
                                />
                            </DemoDisabledTooltip>
                        ) : null}
                    </StyledInnerContainer>

                    <DemoDisabledTooltip>
                        <TableListsColumnsSelectionContainer
                            isDisabled={areWriteActionsDisabled || !isColumnConfigReady || isPending}
                            onSuggestionsApply={handleSuggestionsApply}
                            renderSelectionModal={SelectionModalContainer}
                        />
                    </DemoDisabledTooltip>
                </>
            )}
        </TableActionsPanel>
    );
};

export default TableActionsPanelContainer;
